document.addEventListener('DOMContentLoaded', function () {
    // Selectors scoped to our new class structure
    const wrappers = document.querySelectorAll('.video-experience-wrapper');

    wrappers.forEach(wrapper => {
        const sectionId = wrapper.dataset.sectionId;
        const basePath = wrapper.dataset.basePath || '/pages/how-to-use';
        const nav = wrapper.querySelector('.video-tabs-nav');
        // Note: Tabs are now rendered by blocks, so we query them live
        const indicator = nav.querySelector('.video-tabs-nav__indicator');
        const prevBtn = wrapper.querySelector('.video-tabs-arrow--prev');
        const nextBtn = wrapper.querySelector('.video-tabs-arrow--next');
        const chaptersContainer = wrapper.querySelector('.video-chapters-container');
        const videoPlayer = wrapper.querySelector('.video-player-container video');
        const ctaContainer = wrapper.querySelector('.video-cta-container');
        const seoFooter = document.getElementById('video-seo-footer');
        const seoFooterContent = seoFooter ? seoFooter.querySelector('.seo-footer-content') : null;
        const faqList = document.getElementById('video-faq-list');

        let tabs = nav.querySelectorAll('.video-tab');

        // Visual Stability Fix: 
        // Set data-label to content to reserve space for bold text
        tabs.forEach(tab => {
            const label = tab.querySelector('.video-tab__label');
            if (label && label.textContent) {
                label.setAttribute('data-label', label.textContent.trim());
            }
        });
        // Helper: Slugify text for URL
        const slugify = (text) => {
            try {
                return (text || '').toString().toLowerCase().trim()
                    .replace(/\s+/g, '-')           // Replace spaces with -
                    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                    .replace(/\-\-+/g, '-');        // Replace multiple - with single -
            } catch (e) {
                console.error("Slugify error:", e);
                return '';
            }
        };

        // Helper: Update URL state
        const updateUrl = (tab) => {
            try {
                if (!tab) return;
                const label = tab.querySelector('.video-tab__label');
                const rawText = label ? (label.getAttribute('data-label') || label.textContent) : '';
                const tabSlug = slugify(rawText);
                if (!tabSlug) return;

                // Clean URL format: /how-to-use/the-moxie-curly-routine
                const newPath = `/${basePath}/${tabSlug}`;
                if (window.location.pathname !== newPath) {
                    window.history.replaceState({}, '', newPath);
                }
            } catch (err) {
                console.error("URL Update Error:", err);
            }
        };

        // --- 1. Carousel Navigation Logic ---
        const updateArrows = () => {
            if (!nav) return;
            // Tolerance of 5px
            prevBtn.disabled = nav.scrollLeft <= 5;
            nextBtn.disabled = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 5;
        };

        const scrollAmount = () => {
            return nav.clientWidth / 3;
        };

        if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', () => {
                nav.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
            });
            nextBtn.addEventListener('click', () => {
                nav.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
            });
            nav.addEventListener('scroll', () => {
                updateArrows(); // Debounce if needed
            });
            updateArrows();
            window.addEventListener('resize', updateArrows);
        }

        // --- 2. Indicator Logic ---
        /**
         * Updates the position and width of the active tab indicator (Yellow Shape).
         * 
         * Logic:
         * - Mobile (<= 767px): Uses static CSS shape (no JS calculation).
         * - Desktop: Calculates position relative to the image and extends a "tail" to the left.
         * 
         * @param {HTMLElement} tab - The active tab element.
         */
        const moveIndicator = (tab) => {
            // MOBILE OPTIMIZATION:
            // On mobile devices, we use a static CSS pseudo-element for performance.
            if (window.innerWidth <= 767) return;

            if (!indicator || !tab) return;

            const label = tab.querySelector('.video-tab__label');
            const imageWrapper = tab.querySelector('.video-tab__image-wrapper');

            // Safety check
            if (!label || !imageWrapper) {
                return;
            }

            // --- 1. CONFIGURATION ---
            // TAIL_EXTENSION: Pixels to extend the indicator to the left of the image.
            const TAIL_EXTENSION = 15;

            // BUFFER_RIGHT: Extra padding on the right side of the text label.
            const BUFFER_RIGHT = 10;

            // --- 2. MEASUREMENTS ---
            const navRect = nav.getBoundingClientRect();
            const imageRect = imageWrapper.getBoundingClientRect();
            const labelRect = label.getBoundingClientRect();
            const currentScroll = nav.scrollLeft;

            // --- 3. CALCULATION (DESKTOP) ---
            // Horizontal Layout: [Image] -> [Text]

            // Start Point (Left): 
            // Relative to Image Left, extended by TAIL_EXTENSION to the left.
            const contentLeftAbs = imageRect.left;
            const finalLeft = (contentLeftAbs - navRect.left) + currentScroll - TAIL_EXTENSION;

            // End Point (Right) & Width:
            // Width covers from Image Left to Label Right + Tail + Buffer.
            const contentRightAbs = labelRect.right;
            const baseContentWidth = contentRightAbs - contentLeftAbs; // Distance between Image Left and Text Right

            const finalWidth = TAIL_EXTENSION + baseContentWidth + BUFFER_RIGHT;

            // Vertical Alignment:
            const finalTop = '50%';
            const transform = 'translateY(-50%)';

            // --- 4. APPLY STYLES ---
            indicator.style.width = `${finalWidth}px`;
            indicator.style.left = `${finalLeft}px`;
            indicator.style.top = finalTop;
            indicator.style.transform = transform;
        };

        // --- 3. Video & Chapter Logic ---

        const parseTime = (timeStr) => {
            if (!timeStr) return 0;
            const parts = timeStr.toString().trim().split(':');
            if (parts.length === 2) return parseInt(parts[0]) * 60 + parseInt(parts[1]);
            if (parts.length === 3) return parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2]);
            return parseInt(timeStr);
        };

        // Helper: Sync SEO meta tags to the active tab's mapped page.
        // The page swap is client-side (replaceState, no reload), so the
        // server-rendered title/description/canonical would otherwise stay
        // frozen on the entry page. We update them from each tab's payload.
        const updateMeta = (dataDiv) => {
            const getText = (sel) => {
                const node = dataDiv.querySelector(sel);
                return node ? node.textContent.trim() : '';
            };

            const title = getText('.data-seo-title');
            const description = getText('.data-seo-description');
            const canonical = getText('.data-canonical');

            if (title) document.title = title;

            if (description) {
                ['meta[name="description"]', 'meta[property="og:description"]', 'meta[name="twitter:description"]']
                    .forEach(sel => {
                        const tag = document.head.querySelector(sel);
                        if (tag) tag.setAttribute('content', description);
                    });
            }

            if (canonical) {
                const link = document.head.querySelector('link[rel="canonical"]');
                if (link) link.setAttribute('href', canonical);
            }
        };

        // Updated for DOM-based data from Nested Blocks
        const updateContentFromBlock = (blockId) => {
            const dataTemplate = document.getElementById(`data-${blockId}`);
            if (!dataTemplate) return;
            const dataDiv = dataTemplate.content;

            updateMeta(dataDiv);

            // 1. Video
            const videoUrl = dataDiv.querySelector('.data-video-url').textContent.trim();
            const poster = dataDiv.querySelector('.data-video-poster').textContent.trim();

            if (videoPlayer && videoUrl && videoPlayer.src !== videoUrl) {
                // Reserve the current player height during the source swap so the
                // container doesn't collapse while load() clears the video's
                // intrinsic size (which briefly pulls the footer up). Released
                // once the new video reports its own dimensions.
                const container = videoPlayer.closest('.video-player-container');
                if (container) {
                    container.style.minHeight = `${container.offsetHeight}px`;
                    videoPlayer.addEventListener('loadedmetadata', () => {
                        container.style.minHeight = '';
                    }, { once: true });
                }

                videoPlayer.src = videoUrl;
                videoPlayer.poster = poster;
                videoPlayer.load();
                const playPromise = videoPlayer.play();
                if (playPromise) playPromise.catch(() => { });
            }

            // 2. Chapters (They are ALREADY HTML buttons in the hidden div!)
            chaptersContainer.innerHTML = '';
            const chapterSource = dataDiv.querySelector('.data-chapters');
            if (chapterSource) {
                // Find actual buttons (ignoring potential block wrappers)
                const sourceButtons = chapterSource.querySelectorAll('.chapter-btn');
                const buttons = Array.from(sourceButtons).map(node => node.cloneNode(true));

                buttons.forEach((btn, idx) => {
                    // Activate first by default visually
                    if (idx === 0) btn.classList.add('active');

                    // Add listeners to these new buttons
                    btn.addEventListener('click', () => {
                        // UI
                        chaptersContainer.querySelectorAll('.chapter-btn').forEach(b => b.classList.remove('active'));
                        btn.classList.add('active');
                        // Seek
                        const timeStr = btn.dataset.time;
                        const seconds = parseTime(timeStr);
                        if (videoPlayer) {
                            videoPlayer.currentTime = seconds;
                            videoPlayer.play().catch(() => { });
                        }
                    });

                    chaptersContainer.appendChild(btn);
                });
            }

            // 3. CTA Button (per-tab link, sits directly below the video)
            if (ctaContainer) {
                const ctaSource = dataDiv.querySelector('.data-cta');
                ctaContainer.innerHTML = ctaSource ? ctaSource.innerHTML.trim() : '';
            }

            // 4. SEO Footer (per-tab content)
            if (seoFooter && seoFooterContent) {
                const seoSource = dataDiv.querySelector('.data-seo-footer');
                const html = seoSource ? seoSource.innerHTML.trim() : '';
                seoFooterContent.innerHTML = html;
                seoFooter.hidden = html === '';
            }

            // 5. FAQs (per-tab content)
            if (faqList) {
                faqList.innerHTML = '';
                const faqSource = dataDiv.querySelector('.data-faq');
                if (faqSource) {
                    const faqItems = Array.from(faqSource.querySelectorAll('.faq-item')).map(node => node.cloneNode(true));
                    faqItems.forEach(item => faqList.appendChild(item));
                }
            }
        };

        const activateTab = (tab, updateHistory = true) => {
            if (!tab) return;

            // UI
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            moveIndicator(tab);

            // Data
            const blockId = tab.dataset.blockId;
            updateContentFromBlock(blockId);

            // URL Update
            if (updateHistory) {
                updateUrl(tab);
            }
        };

        // --- 4. Init ---
        if (tabs.length > 0) {
            // Detect active tab from clean URL path (/how-to-use/{slug})
            // Also handles /pages/how-to-use-{slug} (after Shopify redirect) and legacy ?video= param
            const pathSlug = (() => {
                const path = window.location.pathname;
                const cleanMatch = path.match(new RegExp(`^\\/${basePath}\\/(.+)$`));
                if (cleanMatch) return cleanMatch[1];
                const pagesMatch = path.match(new RegExp(`^\\/pages\\/${basePath}-(.+)$`));
                if (pagesMatch) return pagesMatch[1];
                return null;
            })();
            const videoParam = new URLSearchParams(window.location.search).get('video');
            const activeSlug = pathSlug || videoParam;

            let initialTab = tabs[0];

            if (activeSlug) {
                const foundTab = Array.from(tabs).find(tab => {
                    const label = tab.querySelector('.video-tab__label');
                    const text = label ? (label.getAttribute('data-label') || label.textContent) : '';
                    return slugify(text) === activeSlug;
                });
                if (foundTab) {
                    initialTab = foundTab;
                }
            }

            // Activate the determined tab (true = update URL immediately so first tab is reflected)
            activateTab(initialTab, true);
            
            // Auto-scroll to the active tab if it's not the first one
            if (initialTab !== tabs[0]) {
                 setTimeout(() => {
                    initialTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                 }, 500);
            }

            tabs.forEach(tab => {
                tab.addEventListener('click', () => activateTab(tab, true));
            });

            setTimeout(() => moveIndicator(initialTab), 500);
            window.addEventListener('resize', () => {
                const active = nav.querySelector('.video-tab.active');
                if (active) moveIndicator(active);
            });
        }

        // --- 5. Video Time Sync (New Feature) ---
        if (videoPlayer) {
            videoPlayer.addEventListener('timeupdate', () => {
                const currentTime = videoPlayer.currentTime;
                const buttons = Array.from(chaptersContainer.querySelectorAll('.chapter-btn'));

                let activeCandidate = null;

                // Find the chapter with the highest time <= currentTime
                buttons.forEach(btn => {
                    const timeVal = parseTime(btn.dataset.time);
                    // Add slight tolerance or stick to <=
                    if (timeVal <= currentTime + 0.5) { // 0.5s tolerance for near-misses
                        activeCandidate = btn;
                    }
                });

                if (activeCandidate) {
                    // Only update DOM if changed to prevent thrashing
                    if (!activeCandidate.classList.contains('active')) {
                        buttons.forEach(b => b.classList.remove('active'));
                        activeCandidate.classList.add('active');
                    }
                }
            });
        }

        // Shopify Editor Integration (Design Mode Support)
        document.addEventListener('shopify:block:select', function (event) {
            const blockId = event.detail.blockId;
            const tab = nav.querySelector(`[data-block-id="${blockId}"]`);
            if (tab) {
                activateTab(tab);
                // Scroll to it
                tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
        });
    });
});
